import pkdApi from 'store/api/pkd';

const userApi = pkdApi.injectEndpoints({
  endpoints : (build) => ({
    createUser : build.mutation({
      query : (body) => ({
        url    : '/users?include=persons',
        method : 'POST',
        body,
      }),
      invalidatesTags : ['User'],
    }),
    getCurrentUser : build.query({
      query : () => ({
        url    : '/users/current?include=persons,study_roles,person_attribute',
        method : 'GET',
      }),
      providesTags : ['User'],
    }),
    getCurrentParticipant : build.query({
      query : () => ({
        url    : '/users/current?include=persons,study_roles,person_attribute',
        method : 'GET',
      }),
      transformResponse : ({ data }) => {
        const person = data?.included?.[0]?.[0]?.data;
        if (person) {
          person.user = data.attributes;
        }
        return person;
      },
      providesTags : ['User'],
    }),
    changeUserPassword : build.mutation({
      query : ({ userId, body }) => ({
        url        : `../v3/users/${userId}/change-password`,
        method     : 'Post',
        autoLogout : false,
        body,
      }),
    }),
    resendVerificationEmail : build.mutation({
      query : ({ userId }) => ({
        url        : `../v3/users/${userId}/resend-verification-emails`,
        method     : 'POST',
        autoLogout : false,
      }),
      providesTags : ['Auth0Metadata'],
    }),
    updateAuth0Metadata : build.mutation({
      query : ({ userId, userMetadata }) => ({
        url        : `../v3/users/${userId}/update-metadata`,
        method     : 'Post',
        autoLogout : false,
        body       : {
          data : {
            user_metadata : userMetadata,
          },
        },
      }),
      invalidatesTags : ['MFAAuthenticators', 'UserMetadata'],
    }),
    getAuth0Metadata : build.query({
      query : ({ userId }) => ({
        url        : `../v3/users/${userId}/get-metadata`,
        method     : 'Get',
        autoLogout : false
      }),
      providesTags : ['UserMetadata'],
    }),
    updateUser : build.mutation({
      query : (body, params) => ({
        url    : '/users',
        method : 'PATCH',
        body,
        params,
      }),
      invalidatesTags : ['User'],
    }),
  }),
  overrideExisting : false,
});

export const {
  useCreateUserMutation,
  useGetCurrentUserQuery,
  useGetCurrentParticipantQuery,
  useGetAuth0MetadataQuery,
  useUpdateUserMutation,
  useUpdateAuth0MetadataMutation,
  useChangeUserPasswordMutation,
  useResendVerificationEmailMutation,
} = userApi;
